'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/_react-dom@15.7.0@react-dom/index.js
// module id = 37
// module chunks = 0